import { Icon, Link, RyeconInfoOutline, Tooltip } from '@dbt-labs/sourdough';

import { TwoLineHeader } from './TableHeader';

/**
 * You should favor using CustomCell or LinkCell if you need to override Cell to ensure
 * hovering over the cell will reveal tooltip content
 */
export const OwnerHeader = () => {
  return (
    <TwoLineHeader
      title="Owner"
      subtitle={
        <div className="flex space-x-1">
          <span>
            <Link to="https://docs.getdbt.com/docs/build/groups" isInternal={false}>
              Define owners
            </Link>
          </span>
          <Tooltip
            content={
              <div className="whitespace-normal text-wrap">
                Define the owner by using groups.{' '}
                <Link to="https://docs.getdbt.com/docs/build/groups" isInternal={false}>
                  Learn how.
                </Link>
              </div>
            }
            placement="top-end"
          >
            <Icon ryecon={RyeconInfoOutline} />
          </Tooltip>
        </div>
      }
    />
  );
};
